  const path = {
    bs_o: '/files/app/1_Кемерово/11_БС_ОФ/11_',
    bs_z: '/files/app/1_Кемерово/12_БС_ЗФ/12_',
    bs_oz: '/files/app/1_Кемерово/18_БС_ОЗФ/18_',
    mag_o: '/files/app/1_Кемерово/13_МАГ_ОФ/13_',
    mag_z: '/files/app/1_Кемерово/17_МАГ_ЗФ/17_',
    mag_oz: '/files/app/1_Кемерово/14_МАГ_ОЗФ/14_',
    asp_o: '/files/app/1_Кемерово/15_АСП_ОФ/15_',
    asp_z: '/files/app/1_Кемерово/16_АСП_ЗФ/16_',
    spo_o: '/files/app/1_Кемерово/19_СПО_ОФ/19_',
    prok_bs_o: '/files/app/2_Прокопьевск/21_БС_ОФ/21_',
    prok_bs_z: '/files/app/2_Прокопьевск/22_БС_ЗФ/22_',
    prok_bs_oz: '/files/app/2_Прокопьевск/28_БС_ОЗФ/28_',
    prok_mag_o: '/files/app/2_Прокопьевск/23_МАГ_ОФ/23_',
    prok_mag_oz: '/files/app/2_Прокопьевск/24_МАГ_ОЗФ/24_',
    prok_spo_o: '/files/app/2_Прокопьевск/29_СПО_ОФ/29_',

    nkvz_bs_o: '/files/app/3_Новокузнецк/31_БС_ОФ/31_',
    nkvz_bs_z: '/files/app/3_Новокузнецк/32_БС_ЗФ/32_',
    nkvz_bs_oz: '/files/app/3_Новокузнецк/38_БС_ОЗФ/38_',
    nkvz_spo_o: '/files/app/3_Новокузнецк/39_СПО_ОФ/39_',

    mezh_bs_o: '/files/app/4_Междуреченск/41_БС_ОФ/41_',
    mezh_bs_z: '/files/app/4_Междуреченск/42_БС_ЗФ/42_',
    mezh_bs_oz: '/files/app/4_Междуреченск/48_БС_ОЗФ/48_',
    mezh_spo_o: '/files/app/4_Междуреченск/49_СПО_ОФ/49_',

    bel_bs_o: '/files/app/5_Белово/51_БС_ОФ/51_',
    bel_bs_z: '/files/app/5_Белово/52_БС_ЗФ/52_',
    bel_bs_oz: '/files/app/5_Белово/58_БС_ОЗФ/58_',
    bel_spo_o: '/files/app/5_Белово/59_СПО_ОФ/59_',
  }
  const urls = {
    1: {
      1: {
        kcp: path.bs_o + 'КЦП.pdf',
        application: path.bs_o + 'Заявление.pdf',
        application_example: path.bs_o + 'Заявление_(образец).pdf',
        priority: path.bs_o + 'Приоритетность_ОП.pdf',
        priority_example: path.bs_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.bs_o + 'Согласие_на_зачисление.pdf',
      },
      2: {
        kcp: path.bs_z + 'КЦП.pdf',
        application: path.bs_z + 'Заявление.pdf',
        application_example: path.bs_z + 'Заявление_(образец).pdf',
        priority: path.bs_z + 'Приоритетность_ОП.pdf',
        priority_example: path.bs_z + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.bs_z + 'Согласие_на_зачисление.pdf',
      },
      8: {
        kcp: path.bs_oz + 'КЦП.pdf',
        application: path.bs_oz + 'Заявление.pdf',
        application_example: path.bs_oz + 'Заявление_(образец).pdf',
        priority: path.bs_oz + 'Приоритетность_ОП.pdf',
        priority_example: path.bs_oz + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.bs_oz + 'Согласие_на_зачисление.pdf',
      },

      3: {
        kcp: path.mag_o + 'КЦП.pdf',
        application: path.mag_o + 'Заявление.pdf',
        application_example: path.mag_o + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.mag_o + 'Согласие_на_зачисление.pdf',
      },
      7: {
        kcp: path.mag_z + 'КЦП.pdf',
        application: path.mag_z + 'Заявление.pdf',
        application_example: path.mag_z + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.mag_z + 'Согласие_на_зачисление.pdf',
      },
      4: {
        kcp: path.mag_oz + 'КЦП.pdf',
        application: path.mag_oz + 'Заявление.pdf',
        application_example: path.mag_oz + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.mag_oz + 'Согласие_на_зачисление.pdf',
      },

      5: {
        kcp: path.asp_o + 'КЦП.pdf',
        application: path.asp_o + 'Заявление.pdf',
        application_example: path.asp_o + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.asp_o + 'Согласие_на_зачисление.pdf',
      },
      6: {
        kcp: path.asp_z + 'КЦП.pdf',
        application: path.asp_z + 'Заявление.pdf',
        application_example: path.asp_z + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.asp_z + 'Согласие_на_зачисление.pdf',
      },

      9: {
        kcp: path.spo_o + 'КЦП.pdf',
        application: path.spo_o + 'Заявление.pdf',
        application_example: path.spo_o + 'Заявление_(образец).pdf',
        priority: path.spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.spo_o + 'Согласие_на_зачисление.pdf',
      },
    },
    2: {
      1: {
        kcp: path.prok_bs_o + 'КЦП.pdf',
        application: path.prok_bs_o + 'Заявление.pdf',
        application_example: path.prok_bs_o + 'Заявление_(образец).pdf',
        priority: path.prok_bs_o + 'Приоритетность_ОП.pdf',
        priority_example: path.prok_bs_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.prok_bs_o + 'Согласие_на_зачисление.pdf',
      },
      2: {
        kcp: path.prok_bs_z + 'КЦП.pdf',
        application: path.prok_bs_z + 'Заявление.pdf',
        application_example: path.prok_bs_z + 'Заявление_(образец).pdf',
        priority: path.prok_bs_z + 'Приоритетность_ОП.pdf',
        priority_example: path.prok_bs_z + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.prok_bs_z + 'Согласие_на_зачисление.pdf',
      },
      8: {
        kcp: path.prok_bs_oz + 'КЦП.pdf',
        application: path.prok_bs_oz + 'Заявление.pdf',
        application_example: path.prok_bs_oz + 'Заявление_(образец).pdf',
        priority: path.prok_bs_oz + 'Приоритетность_ОП.pdf',
        priority_example: path.prok_bs_oz + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.prok_bs_oz + 'Согласие_на_зачисление.pdf',
      },

      3: {
        kcp: path.prok_mag_o + 'КЦП.pdf',
        application: path.prok_mag_o + 'Заявление.pdf',
        application_example: path.prok_mag_o + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.prok_mag_o + 'Согласие_на_зачисление.pdf',
      },
      4: {
        kcp: path.prok_mag_oz + 'КЦП.pdf',
        application: path.prok_mag_oz + 'Заявление.pdf',
        application_example: path.prok_mag_oz + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.prok_mag_oz + 'Согласие_на_зачисление.pdf',
      },

      9: {
        kcp: path.prok_spo_o + 'КЦП.pdf',
        application: path.prok_spo_o + 'Заявление.pdf',
        application_example: path.prok_spo_o + 'Заявление_(образец).pdf',
        priority: path.prok_spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.prok_spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.prok_spo_o + 'Согласие_на_зачисление.pdf',
      },
    },
    3: {
      1: {
        kcp: path.nkvz_bs_o + 'КЦП.pdf',
        application: path.nkvz_bs_o + 'Заявление.pdf',
        application_example: path.nkvz_bs_o + 'Заявление_(образец).pdf',
        priority: path.nkvz_bs_o + 'Приоритетность_ОП.pdf',
        priority_example: path.nkvz_bs_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.nkvz_bs_o + 'Согласие_на_зачисление.pdf',
      },
      2: {
        kcp: path.nkvz_bs_z + 'КЦП.pdf',
        application: path.nkvz_bs_z + 'Заявление.pdf',
        application_example: path.nkvz_bs_z + 'Заявление_(образец).pdf',
        priority: path.nkvz_bs_z + 'Приоритетность_ОП.pdf',
        priority_example: path.nkvz_bs_z + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.nkvz_bs_z + 'Согласие_на_зачисление.pdf',
      },
      8: {
        kcp: path.nkvz_bs_oz + 'КЦП.pdf',
        application: path.nkvz_bs_oz + 'Заявление.pdf',
        application_example: path.nkvz_bs_oz + 'Заявление_(образец).pdf',
        priority: path.mezh_spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.mezh_spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.nkvz_bs_oz + 'Согласие_на_зачисление.pdf',
      },

      9: {
        kcp: path.nkvz_spo_o + 'КЦП.pdf',
        application: path.nkvz_spo_o + 'Заявление.pdf',
        application_example: path.nkvz_spo_o + 'Заявление_(образец).pdf',
        priority: path.nkvz_spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.nkvz_spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.nkvz_spo_o + 'Согласие_на_зачисление.pdf',
      },
    },
    4: {
      1: {
        kcp: path.mezh_bs_o + 'КЦП.pdf',
        application: path.mezh_bs_o + 'Заявление.pdf',
        application_example: path.mezh_bs_o + 'Заявление_(образец).pdf',
        priority: path.mezh_bs_o + 'Приоритетность_ОП.pdf',
        priority_example: path.mezh_bs_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.mezh_bs_o + 'Согласие_на_зачисление.pdf',
      },
      2: {
        kcp: path.mezh_bs_z + 'КЦП.pdf',
        application: path.mezh_bs_z + 'Заявление.pdf',
        application_example: path.mezh_bs_z + 'Заявление_(образец).pdf',
        priority: path.mezh_bs_z + 'Приоритетность_ОП.pdf',
        priority_example: path.mezh_bs_z + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.mezh_bs_z + 'Согласие_на_зачисление.pdf',
      },
      8: {
        kcp: path.mezh_bs_oz + 'КЦП.pdf',
        application: path.mezh_bs_oz + 'Заявление.pdf',
        application_example: path.mezh_bs_oz + 'Заявление_(образец).pdf',
        priority: path.mezh_spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.mezh_spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.mezh_bs_oz + 'Согласие_на_зачисление.pdf',
      },

      9: {
        kcp: path.mezh_spo_o + 'КЦП.pdf',
        application: path.mezh_spo_o + 'Заявление.pdf',
        application_example: path.mezh_spo_o + 'Заявление_(образец).pdf',
        priority: path.mezh_spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.mezh_spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.mezh_spo_o + 'Согласие_на_зачисление.pdf',
      },
    },
    5: {
      1: {
        kcp: path.bel_bs_o + 'КЦП.pdf',
        application: path.bel_bs_o + 'Заявление.pdf',
        application_example: path.bel_bs_o + 'Заявление_(образец).pdf',
        priority: path.bel_bs_o + 'Приоритетность_ОП.pdf',
        priority_example: path.bel_bs_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.bel_bs_o + 'Согласие_на_зачисление.pdf',
      },
      2: {
        kcp: path.bel_bs_z + 'КЦП.pdf',
        application: path.bel_bs_z + 'Заявление.pdf',
        application_example: path.bel_bs_z + 'Заявление_(образец).pdf',
        priority: path.bel_bs_z + 'Приоритетность_ОП.pdf',
        priority_example: path.bel_bs_z + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.bel_bs_z + 'Согласие_на_зачисление.pdf',
      },
      8: {
        kcp: path.bel_bs_oz + 'КЦП.pdf',
        application: path.bel_bs_oz + 'Заявление.pdf',
        application_example: path.bel_bs_oz + 'Заявление_(образец).pdf',
        priority: '',
        priority_example: '',
        agreement: path.bel_bs_oz + 'Согласие_на_зачисление.pdf',
      },

      9: {
        kcp: path.bel_spo_o + 'КЦП.pdf',
        application: path.bel_spo_o + 'Заявление.pdf',
        application_example: path.bel_spo_o + 'Заявление_(образец).pdf',
        priority: path.bel_spo_o + 'Приоритетность_ОП.pdf',
        priority_example: path.bel_spo_o + 'Приоритетность_ОП_(образец).pdf',
        agreement: path.bel_spo_o + 'Согласие_на_зачисление.pdf',
      },
    },
  }

  export { urls };
